<template>
  <div class="geofence-map-container">
    <div class="map-here" id="mapHere"></div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import mapSettings from '@/values/map-settings'
export default {
  name: 'geofence-map2',
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      activeKml: [],
      test: {
        ctaPoints: [],
        ctaPath: [
          { lat: 33.9518361293, lng: -118.396441488 },
          { lat: 33.9404376198, lng: -118.396411306 },
          { lat: 33.9428921859, lng: -118.397526938 },
          { lat: 33.9418275284, lng: -118.408275099 },
          { lat: 33.9453275395, lng: -118.408771137 },
          { lat: 33.9464253806, lng: -118.40013021 },
          { lat: 33.9485216947, lng: -118.400136515 }
        ],
        assignPoints: [],
        assignPath: [
          { lat: 33.9529341402, lng: -118.394014116 },
          { lat: 33.95272417, lng: -118.379971643 },
          { lat: 33.9473246781, lng: -118.379965937 },
          { lat: 33.9473150916, lng: -118.390095323 },
          { lat: 33.9487758219, lng: -118.390136649 },
          { lat: 33.9487983271, lng: -118.393977504 }
        ]
      },
      mapOptions: mapSettings,
      center: { lat: 33.942791, lng: -118.410042 },
      points: [],
      setCenterTime: ''
    }
  },
  computed: {
    polygons () { return this.$store.state.geofences.map.polygons }
  },
  watch: {
    polygons (value) {
      let self = this
      let kmlGroup = new window.H.map.Group()

      for (let object of self.hereMaps.map.getObjects()) {
        self.hereMaps.map.removeObject(object)
      }

      if (value) {
        let firstPolyon = true
        value.forEach(val => {
          let geofences = self.$store.state.geofences.geofences.items
          let index = geofences.findIndex(x => x.id === val.id)
          let reader = new window.H.data.kml.Reader(geofences[index].kmlFile)
          reader.parse()

          reader.addEventListener('statechange', async function () {
            if (this.getState() === window.H.data.AbstractReader.State.READY) {
              var objects = reader.getParsedObjects()
              if (objects[0] instanceof H.map.Group) {
                objects = objects[0]
              }

              objects.forEach((obj, i, group) => {
                if (obj instanceof H.map.Polygon) {
                  obj.setStyle({
                    strokeColor: val.color,
                    fillColor: self.hexaToDeci(val.color),
                    lineWidth: 2
                  })
                  obj.id = val.id
                  kmlGroup.addObject(obj)

                  if (firstPolyon) {
                    self.hereMaps.map.getViewModel().setLookAtData({
                      bounds: obj.getBoundingBox()
                    })
                  }
                }
              }, true, this)

              firstPolyon = false
            }
          })
          
          self.hereMaps.map.addObject(kmlGroup)
          let layer = reader.getLayer()
          self.hereMaps.map.addLayer(layer)
        })
        // self.setCenter()
      }

    }
  },
  methods: {
    logCTA (e) {
      this.test.ctaPoints.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      })
      console.log('CTA', e)
    },
    logAssignment (e) {
      this.test.assignPoints.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      })
      console.log('CTA', e)
    },
    logMe(e) {
      this.points.push({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      })
      console.log(e)
    },
    hexaToDeci (val) {
      let hex = val.replace('#', '').match(/.{1,2}/g)
      return 'rgba(' + parseInt(hex[0], 16) + ',' + parseInt(hex[1], 16) + ',' +  parseInt(hex[2], 16) + ', .4)'
    },
    setCenter () {
      let self = this
      let group = new window.H.map.Group()
      if (!self.polygons.length) { return }

      let geofences = self.$store.state.geofences.geofences.items
      let index = geofences.findIndex(x => x.id === self.polygons[0].id)

      if (index > -1) {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id === 'groupBound') {
            self.hereMaps.map.removeObject(object)
          }
        }

        let groupObject = new window.H.map.Circle(
          new window.H.geo.Point(geofences[index].lat, geofences[index].lng),
          5000,
          {
            style: {
              fillColor: 'rgba(0, 0, 0, 0)',
              strokeColor: 'rgba(0, 0, 0, 0)'
            }
          }
        )

        group.addObjects([groupObject])
        group.id = 'groupBound'
        self.hereMaps.map.addObject(group)

        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        })
      }

    }
  },
  mounted () {
    let self = this
    let mapContainer = document.getElementById('mapHere')
    self.hereMaps.platform = new window.H.service.Platform({
      apikey: CONFIG.hereApi.key
    })

    let defaultLayers = self.hereMaps.platform.createDefaultLayers()
    self.hereMaps.map = new window.H.Map(mapContainer,
      defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      }
    )

    /* eslint-disable no-unused-vars */
    let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)

    window.addEventListener('resize', () => self.hereMaps.map.getViewPort().resize())
  }
}
</script>

<style lang="scss" scoped>
.geofence-map{
  position: absolute;
  width: 100%;
  height: 100%;
  display:none;
}
.map-here{
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceMap2.vue